import React, { ReactElement } from 'react';
import SwipeableSlider from '../swipeable-slider/swipeable-slider.component';
import TextBlock from '../text-block/text-block.component';
import Image from '../image/image.component';
import useStylesModalSwipeableSlider from './modal-swipeable-slider.styles';

const ModalSwipeableSlider: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const SLIDES_PER_VIEW_DEFAULT: number = 1;

  const {
    imageList,
    imageActiveId,
    imageTextPrefix,
  } = props;

  const { classes } = useStylesModalSwipeableSlider();

  const slideActiveIndex: number = imageList && imageList.length
    ? imageList.findIndex((imageItem: SliderImageItem): boolean => imageItem.id === imageActiveId) : undefined;

  return (
    <SwipeableSlider
      isCentered
      withNoOffset
      withControlsVisible={imageList.length > 1}
      slideActiveIndex={slideActiveIndex}
      slidesPerView={SLIDES_PER_VIEW_DEFAULT}
    >
      {
        imageList.map((imageItem: SliderImageItem): ReactElement => (
          <TextBlock className={classes.modalSwipeableSliderSlide}>
            <Image
              key={imageItem.id}
              text={`${imageTextPrefix ? `${imageTextPrefix} ` : ''}${imageItem.id}`}
              link={imageItem.link}
              className={classes.modalSwipeableSliderImage}
            />
          </TextBlock>
        ))
      }
    </SwipeableSlider>
  );
});

export default ModalSwipeableSlider;
